var i4_Cart_controller = {
	carts: [],		
	products: [],
	inProgress: false,
	initialized: false,
	options: {},
    
    triggers: {
	    productAdded: 'i4-cart:added',
	    productUpdated: 'i4-cart:updated',
	    productDeleted: 'i4-cart:deleted'
    },
	
	ajaxCalls: {
		change: 'product_change',
		delete: 'product_delete',
		viewUpdate: 'view_update'
	},	
	
	setOption: function(options) {
		this.options = options;
	},
	
	register: function(shop_cart) {
		this.carts.push(shop_cart);
	},
	
	initialize: function() {
		this.$body = $('body');		
	},
	
	addProduct: function(productId, options) { 
		if (!this.initialized) {
			this.initialize();
		}
		
		if (!this.inProgress) {
		
			this.inProgress = true;
			
			var parameter = $.extend({
				product_instance_id: productId,
				product_plugin_id: options.pluginId,
				quantity: options.quantity,
				call: this.ajaxCalls.change,
				url_product: options.productUrl
			}, this.options.ajaxParameter);
									
			i4_Ajax.factory().
				set_parameter(jQuery.param(parameter)).
				set_option({
				    on_success: (function(response) {
					    				    				    	
				    	options.onSuccess();
				    	this.$body.trigger(this.triggers.productAdded);
				    	
				    	this.inProgress = false;
				    }).bind(this)
				}).
				run();
		}
	},
	
	updateProduct: function(productId, options) { 
		if (!this.initialized) {
			this.initialize();
		}
		
		if (!this.inProgress) {
		
			this.inProgress = true;

			var parameter = $.extend({
				product_instance_id: productId,
				product_plugin_id: options.pluginId,
				quantity_replace: options.quantity,
				call: this.ajaxCalls.change,
				url_product: options.productUrl
			}, this.options.ajaxParameter);
									
			i4_Ajax.factory().
				set_parameter(jQuery.param(parameter)).
				set_option({
				    on_success: (function(response) {
				    	this.$body.trigger(this.triggers.productUpdated);
				    	
				    	this.inProgress = false;
				    }).bind(this)
				}).
				run();
		}
	},
	
	deleteProduct: function(productId, options) { 
		if (!this.initialized) {
			this.initialize();
		}
		
		if (!this.inProgress) {
		
			this.inProgress = true;

			var parameter = $.extend({
				product_instance_id: productId,
				product_plugin_id: options.pluginId,
				call: this.ajaxCalls.delete
			}, this.options.ajaxParameter);
									
			i4_Ajax.factory().
				set_parameter(jQuery.param(parameter)).
				set_option({
				    on_success: (function(response) {
				    	this.$body.trigger(this.triggers.productDeleted);
				    	
				    	this.inProgress = false;
				    }).bind(this)
				}).
				run();
		}
	}
};
